// Cronômetro do round, compartilhado entre abas.
//
// A tela do juiz de round e a aba grande (rota /Cronometro) leem e escrevem o
// MESMO estado, então dá para pausar de qualquer uma das duas — inclusive com a
// barra de espaço, que é o que o juiz alcança sem olhar para a tela.
//
// O estado mora no localStorage (sobrevive a recarregar a página e a abrir a aba
// grande depois que o round já começou) e as mudanças são avisadas por
// BroadcastChannel, com o evento 'storage' como plano B em navegador antigo.
//
// Guardamos o INSTANTE DO FIM, não os segundos restantes: assim a contagem não
// depende de o timer da aba rodar em dia (aba em segundo plano no celular tem o
// setInterval estrangulado pelo navegador) e as duas abas mostram o mesmo número.

export const DURACAO_MS = 2 * 60 * 1000

const CHAVE = 'cronometro-round'

let canal = null
try {
  canal = new BroadcastChannel('cronometro-round')
} catch (e) {
  canal = null // navegador sem BroadcastChannel: sobra o evento 'storage'
}

export const estadoPadrao = (fightId = 0) => ({
  fightId,
  rodando: false,
  fimEm: 0, // epoch ms do fim (só vale quando rodando)
  restante: DURACAO_MS // ms restantes (só vale quando pausado)
})

export const ler = () => {
  try {
    const cru = localStorage.getItem(CHAVE)
    return cru ? JSON.parse(cru) : null
  } catch (e) {
    return null
  }
}

export const gravar = (estado) => {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(estado))
  } catch (e) { /* localStorage indisponível: segue só no canal */ }
  if (canal) canal.postMessage(estado)
  return estado
}

// ms restantes de um estado, na hora em que for perguntado
export const restanteDe = (estado) => {
  if (!estado) return DURACAO_MS
  if (!estado.rodando) return Math.max(0, estado.restante)
  return Math.max(0, estado.fimEm - Date.now())
}

export const iniciar = (estado, fightId) => {
  const restante = restanteDe(estado) || DURACAO_MS
  return gravar({ fightId, rodando: true, fimEm: Date.now() + restante, restante })
}

export const pausar = (estado, fightId) => {
  return gravar({ fightId, rodando: false, fimEm: 0, restante: restanteDe(estado) })
}

// pausa se estiver correndo, volta do mesmo ponto se estiver parado
export const alternar = (estado, fightId) => {
  if (estado && estado.rodando) return pausar(estado, fightId)
  return iniciar(estado, fightId)
}

export const zerar = (fightId) => gravar(estadoPadrao(fightId))

// Escuta mudanças feitas por qualquer aba. Devolve a função de cancelar.
export const observar = (fn) => {
  const doCanal = (ev) => fn(ev.data)
  const doStorage = (ev) => {
    if (ev.key !== CHAVE || !ev.newValue) return
    try {
      fn(JSON.parse(ev.newValue))
    } catch (e) { /* valor corrompido: ignora */ }
  }
  if (canal) canal.addEventListener('message', doCanal)
  window.addEventListener('storage', doStorage)
  return () => {
    if (canal) canal.removeEventListener('message', doCanal)
    window.removeEventListener('storage', doStorage)
  }
}

export const formatar = (ms) => {
  const total = Math.max(0, Math.ceil(ms / 1000))
  const m = Math.floor(total / 60)
  const s = total % 60
  return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
}
